import {clearSession, writeNewToken} from "../service/authService/AuthService";
import {removeUserRefreshToken, removeUserToken} from "../service/localStorage/LocalStorageService";
import jwt from 'jwt-decode'

export const actionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    REFRESH_ROLES: 'REFRESH_ROLES',
}

export const initialState = {
    loading: true,
    role: []
}

export function prepareRoles(token) {
    return [...jwt(token).realm_access.roles.map(item => {
        return item
    })]
}

export function reducer(state, action) {

    switch (action.type) {
        case actionTypes.LOGIN: {
            writeNewToken(action.token)
            return {
                ...state,
                loading: false,
                loginState: true,
                role: prepareRoles(action.token),
                // role: [],
            }
        }
        case actionTypes.LOGOUT: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
        case actionTypes.REFRESH_ROLES: {
            return {
                ...state,
                loading: false,
                loginState: true,
                role: action.roles
            }
        }
        default: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                loading: false,
                loginState: false,
                role: []
            }
        }
    }
}

export function setLoginStateDispatch(actionType, token = null, permissions) {
    return {
        type: actionType,
        token: token,
        roles: permissions
    }
}


export const AdminRoles = {
    "SUPER_ADMIN": {
        role: "SUPER_ADMIN",
        name: "مدیر کل"
    }, "FUND_MANAGER": {
        role: "FUND_MANAGER",
        name: "مدیر صندوق"
    }, "SITE_MANAGER": {
        role: "SITE_MANAGER",
        name: "مدیر سایت"
    },
}
export function getAdminRoleInfo(adminRole) {
    switch (adminRole) {
        case AdminRoles.SUPER_ADMIN.role : {
            return AdminRoles.SUPER_ADMIN;
        }
        case AdminRoles.FUND_MANAGER.role : {
            return AdminRoles.FUND_MANAGER;
        }
        case AdminRoles.SITE_MANAGER.role : {
            return AdminRoles.SITE_MANAGER;
        }
        default:
            return AdminRoles.SUPER_ADMIN
    }
}
